import {useEffect, useState} from 'react';
import {THEME_COOKIE_KEY, THEME_DATASET_KEY} from '../constant';
import {ThemeContext} from '../context';
import {ITheme} from '../type';
import {setCookie} from '../util/cookie';

interface IProps {
  children: React.ReactNode;
  initialTheme: ITheme;
}

export default function ThemeProvider({children, initialTheme}: IProps) {
  const [theme, setTheme] = useState<ITheme>(initialTheme);

  useEffect(() => {
    document.body.dataset[THEME_DATASET_KEY] = theme;
    setCookie({key: THEME_COOKIE_KEY, value: theme});
  }, [theme]);

  return (
    <ThemeContext.Provider value={{theme, setTheme}}>
      {children}
    </ThemeContext.Provider>
  );
}
